import {
  Alert,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from '@mui/lab';
import { api } from 'src/Api';

export default function AddDocumentModal({ onClose, getdata, adddocid, getserviceid }) {
  const token = localStorage.getItem('token');
  const [file, setFile] = useState('');
  const [loading, setloading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [roleList, setroleList] = useState([
    { id: 333, name: 'All' },
    { id: 1, name: 'User' },
    { id: 2, name: 'Admin' }
  ]);
  const [role, setrole] = useState();

  const handleFileChange = (e) => {
    // setFile(e.target.files);

    const selectedFile = e.target.files[0]; // Only allow one file
    if (selectedFile) {
      setFile(selectedFile); // Set the selected file
    }

    // const newFiles = Array.from(e.target.files);
    // setFile((prevFiles) => {
    //   if (!Array.isArray(prevFiles)) {
    //     return { ...newFiles };
    //   }
    //   return [...prevFiles, ...newFiles];
    // });
  };

  const handleRemoveFile = (index) => {
    setFile('');
    // setFile((prev) => prev.filter((_, i) => i !== index));
  };

  const handleFileDoc = () => {
    setloading(true);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('customer_service_id', adddocid);
    formdata.append('file', file);
    // file.map((value) => {
    //   formdata.append(`file`, value);
    // });
    role && formdata.append('step_id', role?.id);
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: formdata,
      headers: myHeaders
    };

    fetch(api.save_service_document, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          getdata();
          setFile([]);
        } else {
          console.log('error', result.message);
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
        setTimeout(() => {
          handleSnackbarClose();
        }, 2000);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  useEffect(() => {
    if (getserviceid) {
      handleGetSteps();
    }
  }, []);
  const handleGetSteps = () => {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('service_id', getserviceid?.service_id);
    formdata.append('sub_service_id', getserviceid?.sub_service_id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata
    };
    fetch(api.get_steps, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success) {
          // localStorage.setItem('stepsData', JSON.stringify(result?.data));
          setroleList(result?.data);
        }
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      })
      .finally(() => setloading(false));
  };
  console.log('role file', file);
  return (
    <Box>
      <Box
        sx={{
          border: '2px dashed',
          borderColor: file ? '#cccccc' : '#f90001',
          padding: 2,
          borderRadius: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 100,
          marginBottom: 2
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
          {/* <Typography>{file?.name}</Typography> */}
        </Stack>

        <IconButton disabled={file ? true : false} variant="contained" component="label">
          <CloudUploadIcon style={{ fontSize: 35, color: file ? '#cccccc' : '#f90001' }} />
          <input
            type="file"
            onChange={handleFileChange}
            id="file-input-bottom"
            // multiple
            style={{ display: 'none' }}
          />
        </IconButton>
      </Box>
      <Box>
        <TextField
          fullWidth
          style={{
            paddingBottom: 5
            // width: '40%'
            // marginLeft: '2.5%'
          }}
          select
          value={role}
          label={'Select Step'}
          onChange={(e) => {
            setrole(e.target.value);
          }}
          className="width_full_status"
        >
          {roleList.map((option) => (
            <MenuItem key={option.id} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {file && (
        <Box>
          <List style={{ marginBottom: 10 }}>
            {/* {file.map((doc, index) => ( */}
            <ListItem
              // key={index}
              style={{ backgroundColor: 'rgba(0,0,0,0.05)', borderRadius: 5 }}
              secondaryAction={
                <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveFile()}>
                  <DeleteIcon style={{ color: '#f90001', fontSize: 18 }} />
                </IconButton>
              }
            >
              <p style={{ fontSize: 12 }}>{file?.name}</p>
            </ListItem>
            {/* ))} */}
          </List>
        </Box>
      )}

      <Stack
        pt={2}
        sx={{
          flex: 'display',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flexDirection: 'row',
          gap: 1
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          sx={{
            fontSize: 12,
            textTransform: 'none',
            backgroundColor: '#f90000',
            color: 'white',
            '&:hover': {
              backgroundColor: '#ccc',
              boxShadow: 'none'
            }
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={loading ? true : file ? false : true}
          style={{ fontSize: 12 }}
          type="submit"
          variant="contained"
          onClick={handleFileDoc}
          loading={loading}
        >
          Upload File
        </LoadingButton>
      </Stack>

      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
